//frontend\src\data\locationData.js
 
 export const countries = [
  "India", "United States of America (USA)", "Canada", "Australia", "United Kingdom (UK)", "Pakistan", "United Arab Emirates (UAE)", "France", "Germany", "Kingdom of Saudi Arabia (KSA)",
  "Qatar", "Japan", "China", "Russia", "Singapore", "Sri Lanka", "Israel", "Brazil", "Argentina",
  "Mexico", "South Africa", "Italy", "Spain", "Netherlands", "Sweden", "Norway", "Denmark", "Switzerland", 
  "New Zealand", "South Korea", "Indonesia", "Malaysia", "Thailand", "Philippines", "Vietnam",
  "Bangladesh", "Egypt", "Turkey", "Iran", "Ukraine", "Poland", "Portugal", "Belgium", 
  "Austria", "Czech Republic", "Greece", "Hungary", "Finland", "Ireland", "Romania", "Chile", "Colombia",
  "Peru", "Venezuela", "Ecuador", "Bolivia", "Paraguay", "Uruguay", "Cuba", "Honduras", "Guatemala", 
  "El Salvador", "Panama", "Costa Rica", "Jamaica", "Trinidad and Tobago", "Bahamas", "Barbados", 
  "Iceland", "Malta", "Luxembourg", "Cyprus", "Estonia", "Latvia", "Lithuania", "Croatia", 
  "Slovakia", "Slovenia", "Bulgaria", "Serbia", "Montenegro", "Albania", "North Macedonia", "Bahrain", "Afghanistan",
  "Bhutan", "Maldives", "Nepal", "Mongolia", "Taiwan", "Brunei", "Cambodia", "Laos","Myanmar (Burma)","Timor-Leste", "Iraq", "Jordan,",
  "Kuwait", "Lebanon", "Oman", "Palestine", "Syria", "Yemen", "Andorra",
  "Belarus", "Bosnia and Herzegovina", "Liechtenstein", "Moldova", "Monaco", "San Marino", "Vatican City", "Antigua and Barbuda",
  "Belize", "Dominica", "Dominican Republic", "Grenada", "Haiti", "Nicaragua", "Saint Kitts and Nevis",
  "Saint Lucia", "Saint Vincent and the Grenadines", "Guyana", "Suriname", "French Guiana", "Algeria",
  "Libya", "Morocco", "Sudan", "Tunisia", "Western Sahara", "Benin","Burkina Faso", "Cape Verde","Côte d'Ivoire (Ivory Coast)",
  "Ghana", "Guinea", "Guinea-Bissau", "Liberia", "Mali", "Mauritania", "Niger", "Nigeria", "Senegal", "Sierra Leone",
  "Togo", "Angola", "Cameroon", "Central African Republic", "Chad", "Democratic Republic of the Congo", "Republic of the Congo",
  "Equatorial Guinea", "Gabon", "São Tomé and Príncipe", "Burundi", "Comoros", "Djibouti", "Eritrea", "Ethiopia",
  "Kenya", "Madagascar", "Malawi", "Mauritius", "Mozambique", "Rwanda", "Seychelles", "Somalia", "South Sudan", "Tanzania",
  "Uganda", "Zambia", "Zimbabwe","Fiji", "Kiribati", "Marshall Islands", "Micronesia", "Nauru","Palau","Papua New Guinea","Samoa","Solomon Islands",
  "Tonga", "Tuvalu", "Vanuatu", "Botswana", "Eswatini (Swaziland)", "Lesotho", "Namibia", "The Gambia",
  "Armenia","Kazakhstan","Kosovo","Faroe Islands","Saint Pierre and Miquelon", "Montserrat","Aruba","Bonaire",
  "Curaçao","Sint Maarten","Cook Islands", "Niue", "Pitcairn Islands","Tokelau","Wallis and Futuna","New Caledonia",
  "French Polynesia","Guam","Northern Mariana Islands","American Samoa","Christmas Island","Falkland Islands",
  "South Georgia and the South Sandwich Islands","Turkmenistan","Kyrgyzstan","Uzbekistan","Tajikistan","Greenland", 
  "Bouvet Island","Saint Barthélemy","Saint Martin", "Georgia", "Azerbaijan",
 ];
  
  export const states = {
    India: [
      "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa", "Gujarat",
    "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra",
    "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", 
    "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal", "Andaman and Nicobar Islands",
    "Chandigarh", "Dadra and Nagar Haveli and Daman and Diu", "Delhi", "Jammu and Kashmir", "Ladakh",
    "Lakshadweep", "Puducherry"],
  "United States of America (USA)": ["Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"],
  Canada: ["Alberta", "British Columbia", "Manitoba", "New Brunswick", "Newfoundland and Labrador", "Nova Scotia", "Ontario", "Prince Edward Island", "Quebec", "Saskatchewan", "Northwest Territories", "Nunavut", "Yukon"],
  Australia: ["New South Wales", "Victoria", "Queensland", "Western Australia", "South Australia", "Tasmania", "Australian Capital Territory", "Northern Territory"],

  "United Kingdom (UK)": ["England", "Scotland", "Wales", "Northern Ireland"],
  Germany: ["Baden-Württemberg", "Bavaria", "Berlin", "Brandenburg", "Bremen", "Hamburg", "Hesse", "Lower Saxony", "Mecklenburg-Western Pomerania", "North Rhine-Westphalia", "Rhineland-Palatinate", "Saarland", "Saxony", "Saxony-Anhalt", "Schleswig-Holstein", "Thuringia"],
  Brazil: ["Acre", "Alagoas", "Amapá", "Amazonas", "Bahia", "Ceará", "Distrito Federal", "Espírito Santo", 
    "Goiás", "Maranhão", "Mato Grosso", "Mato Grosso do Sul", "Minas Gerais", "Pará", "Paraíba", 
    "Paraná", "Pernambuco", "Piauí", "Rio de Janeiro", "Rio Grande do Norte", "Rio Grande do Sul", 
    "Rondônia", "Roraima", "Santa Catarina", "São Paulo", "Sergipe", "Tocantins"
  ],
  SouthAfrica: ["Eastern Cape", "Free State", "Gauteng", "KwaZulu-Natal", "Limpopo", "Mpumalanga", "North West", "Northern Cape", "Western Cape"],

  "United Arab Emirates (UAE)": ["Abu Dhabi", "Dubai", "Sharjah", "Ajman", "Umm Al-Quwain", "Ras Al Khaimah", "Fujairah"],

  "Kingdom of Saudi Arabia (KSA)": [ // Administrative Regions
    "Riyadh", "Makkah", "Madinah", "Eastern Province", "Al-Qassim", "Hail","Asir", "Tabuk", "Jizan", "Najran", "Al-Bahah", "Al-Jawf", "Northern Borders"],

  Qatar: [
    "Doha", "Al Rayyan", "Al Wakrah", "Al Khor", "Umm Salal", "Al Daayen", "Al Shamal"],

  China: [ // Provinces, Autonomous Regions, and Municipalities
    "Anhui", "Beijing", "Chongqing", "Fujian", "Gansu", "Guangdong", "Guangxi", "Guizhou", "Hainan", "Hebei", "Heilongjiang", "Henan", "Hubei", "Hunan", "Inner Mongolia", "Jiangsu", "Jiangxi", "Jilin", "Liaoning", "Ningxia", "Qinghai", "Shaanxi", "Shandong", "Shanghai", "Shanxi", "Sichuan", "Tianjin", "Tibet", "Xinjiang", "Yunnan", "Zhejiang" ],

  "Sri Lanka": [ // Provinces of Sri Lanka
    "Central Province", "Eastern Province", "Northern Province", "North Central Province", "North Western Province", "Sabaragamuwa Province", "Southern Province","Uva Province", "Western Province"],

  Bahrain: [ // Governorates of Bahrain
    "Capital Governorate", "Muharraq Governorate", "Northern Governorate", "Southern Governorate"],

  Japan: [ // Prefectures of Japan
    "Hokkaido", "Aomori", "Iwate", "Miyagi", "Akita", "Yamagata", "Fukushima",
    "Ibaraki", "Tochigi", "Gunma", "Saitama", "Chiba", "Tokyo", "Kanagawa",
    "Niigata", "Toyama", "Ishikawa", "Fukui", "Yamanashi", "Nagano", "Gifu",
    "Shizuoka", "Aichi", "Mie", "Shiga", "Kyoto", "Osaka", "Hyogo", "Nara",
    "Wakayama", "Tottori", "Shimane", "Okayama", "Hiroshima", "Yamaguchi",
    "Tokushima", "Kagawa", "Ehime", "Kochi", "Fukuoka", "Saga", "Nagasaki",
    "Kumamoto", "Oita", "Miyazaki", "Kagoshima", "Okinawa"],

  Singapore: [ // Singapore does not have states; it has districts/towns
    "Central Region", "East Region", "North Region", "North-East Region", "West Region"],

  Israel: [ // Districts of Israel
    "Central District", "Haifa District", "Jerusalem District", "Northern District",
    "Southern District", "Tel Aviv District", "Judea and Samaria Area (West Bank)"],
   
  Pakistan: [ // Provinces and territories of Pakistan
    "Pak Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan",
    "Islamabad Capital Territory", "Azad Jammu and Kashmir", "Gilgit-Baltistan"],

  Russia: [ // Federal subjects of Russia (Oblasts, Republics, Territories)
    "Moscow", "Saint Petersburg", "Amur Oblast", "Arkhangelsk Oblast", "Astrakhan Oblast",
    "Belgorod Oblast", "Bryansk Oblast", "Chelyabinsk Oblast", "Irkutsk Oblast",
    "Kaliningrad Oblast", "Khabarovsk Krai", "Krasnoyarsk Krai", "Leningrad Oblast",
    "Nizhny Novgorod Oblast", "Novosibirsk Oblast", "Omsk Oblast", "Orenburg Oblast",
    "Perm Krai", "Primorsky Krai", "Rostov Oblast", "Saratov Oblast", "Sverdlovsk Oblast",
    "Tomsk Oblast", "Tver Oblast", "Volgograd Oblast", "Vologda Oblast", "Voronezh Oblast",
    "Tatarstan", "Bashkortostan", "Dagestan", "Sakha Republic (Yakutia)"],

  Bangladesh: [ // Divisions of Bangladesh
    "Barisal", "Chittagong", "Dhaka", "Khulna", "Mymensingh", "Rajshahi", "Rangpur", "Sylhet"],

  France: [ // Regions of France
    "Auvergne-Rhône-Alpes", "Bourgogne-Franche-Comté", "Brittany", "Centre-Val de Loire",
    "Corsica", "Grand Est", "Hauts-de-France", "Île-de-France", "Normandy",
    "Nouvelle-Aquitaine", "Occitanie", "Pays de la Loire", "Provence-Alpes-Côte d'Azur"
  ],

  Argentina: [ // Provinces of Argentina
    "Buenos Aires", "Catamarca", "Chaco", "Chubut", "Córdoba", "Corrientes", "Entre Ríos", "Formosa", "Jujuy", "La Pampa", "La Rioja", "Mendoza", "Misiones", "Neuquén", "Río Negro", "Salta", "San Juan", "San Luis", "Santa Cruz", "Santa Fe", "Santiago del Estero", "Tierra del Fuego", "Tucumán"],

  Mexico: [ // States of Mexico
    "Aguascalientes", "Baja California", "Baja California Sur", "Campeche", "Chiapas", "Chihuahua", "Coahuila", "Colima", "Durango", "Guanajuato", "Guerrero", "Hidalgo", "Jalisco", "Mexico City", "Michoacán", "Morelos", "Nayarit", "Nuevo León", "Oaxaca", "Puebla", "Querétaro", "Quintana Roo", "San Luis Potosí", "Sinaloa", "Sonora", "Tabasco", "Tamaulipas", "Tlaxcala", "Veracruz", "Yucatán", "Zacatecas"],

  "South Africa": [ // Provinces of South Africa
    "Eastern Cape", "Free State", "Gauteng", "KwaZulu-Natal", "Limpopo", 
    "Mpumalanga", "North West", "Northern Cape", "Western Cape"
  ],

  Italy: [ // Regions of Italy
    "Abruzzo", "Basilicata", "Calabria", "Campania", "Emilia-Romagna", "Friuli Venezia Giulia", "Lazio", "Liguria", "Lombardy", "Marche", "Molise", "Piedmont", "Puglia", "Sardinia", "Sicily", "Tuscany", "Trentino-Alto Adige", "Umbria", "Aosta Valley", "Veneto"],

  Spain: [ // Autonomous Communities of Spain
    "Andalusia", "Aragon", "Asturias", "Balearic Islands", "Basque Country", "Canary Islands", "Cantabria", "Castile and León", "Castilla-La Mancha", "Catalonia", "Extremadura", "Galicia", "La Rioja", "Madrid", "Murcia", "Navarre", "Valencian Community"],

  Netherlands: [ // Provinces of the Netherlands
    "Drenthe", "Flevoland", "Friesland", "Gelderland", "Groningen", 
    "Limburg", "North Brabant", "North Holland", "Overijssel", "South Holland", 
    "Utrecht", "Zeeland"
  ],

  Sweden: [ // Counties of Sweden
    "Blekinge", "Dalarna", "Gävleborg", "Gotland", "Halland", "Jämtland", "Jönköping", "Kalmar", "Kronoberg", "Norrbotten", "Örebro", "Östergötland", "Skåne", "Södermanland", "Stockholm", "Uppsala", "Värmland", "Västerbotten", "Västernorrland", "Västmanland", "Västra Götaland"],

  "Norway": [ // Counties of Norway
    "Agder", "Innlandet", "Møre og Romsdal", "Nordland", "Oslo", "Rogaland", "Troms og Finnmark", "Trøndelag", "Vestfold og Telemark", "Vestland", "Viken"],

  "Denmark": [ // Regions of Denmark
    "Capital Region", "Central Denmark Region", "North Denmark Region", "Region of Southern Denmark", "Zealand Region"
  ],

  "Switzerland": [ // Cantons of Switzerland
    "Aargau", "Appenzell Innerrhoden", "Appenzell Ausserrhoden", "Basel-Landschaft", "Basel-Stadt", "Bern", "Fribourg", "Geneva", "Glarus", "Graubünden", "Jura", "Lucerne", "Neuchâtel", "Nidwalden", "Obwalden", "Schaffhausen", "Schwyz", "Solothurn", "St. Gallen", "Thurgau", "Ticino", "Uri", "Valais", "Vaud", "Zug", "Zurich"],

  "New Zealand": [ // Regions of New Zealand
    "Auckland", "Bay of Plenty", "Canterbury", "Gisborne", "Hawke's Bay", "Manawatu-Whanganui", "Marlborough", "Nelson", "Northland", "Otago", "Southland", "Taranaki", "Tasman", "Waikato", "Wellington", "West Coast"],

  "South Korea": [ // Provinces and Special Cities of South Korea
    "Seoul", "Busan", "Daegu", "Incheon", "Gwangju", "Daejeon", "Ulsan", "Sejong", "Gyeonggi", "Gangwon", "Chungcheongbuk", "Chungcheongnam", "Jeollabuk", "Jeollanam", "Gyeongsangbuk", "Gyeongsangnam", "Jeju"],

  "Indonesia": [ // Provinces of Indonesia
    "Aceh", "Bali", "Banten", "Bengkulu", "Central Java", "Central Kalimantan", "Central Sulawesi", "East Java", "East Kalimantan", "East Nusa Tenggara", "Gorontalo", "Jakarta", "Jambi", "Lampung", "Maluku", "North Kalimantan", "North Maluku", "North Sulawesi", "North Sumatra", "Papua", "Riau", "South Kalimantan", "South Sulawesi", "South Sumatra", "West Java", "West Kalimantan", "West Nusa Tenggara", "West Papua", "West Sulawesi", "West Sumatra", "Yogyakarta"],

  "Malaysia": [ // States and Federal Territories of Malaysia
    "Johor", "Kedah", "Kelantan", "Malacca", "Negeri Sembilan", "Pahang", "Penang", "Perak", "Perlis", "Sabah", "Sarawak", "Selangor", "Terengganu", "Kuala Lumpur", "Labuan", "Putrajaya"],

  "Thailand": [ // Provinces of Thailand
    "Bangkok", "Chiang Mai", "Chiang Rai", "Nakhon Ratchasima", "Nakhon Si Thammarat", "Phuket", "Pattani", "Rayong", "Samut Prakan", "Songkhla", "Surat Thani", "Udon Thani"],

  "Philippines": [ // Regions of the Philippines
    "Ilocos Region", "Cagayan Valley", "Central Luzon", "Calabarzon", "Mimaropa", "Bicol Region", "Western Visayas", "Central Visayas", "Eastern Visayas", "Zamboanga Peninsula", "Northern Mindanao", "Davao Region", "Soccsksargen", "Caraga", "Bangsamoro Autonomous Region", "National Capital Region (NCR)"],

  "Vietnam": [ // Regions of Vietnam
    "An Giang", "Bà Rịa-Vũng Tàu", "Bắc Giang", "Bắc Kạn", "Bạc Liêu", "Bắc Ninh", "Bến Tre", "Bình Định", "Bình Dương", "Bình Phước", "Bình Thuận", "Cà Mau", "Cần Thơ", "Đà Nẵng", "Đắk Lắk", "Đồng Nai", "Đồng Tháp", "Hà Nội", "Hải Phòng", "Hồ Chí Minh City"],

  "Egypt": [ // Governorates of Egypt
    "Alexandria", "Aswan", "Asyut", "Beheira", "Beni Suef", "Cairo", "Dakahlia", "Damietta", "Faiyum", "Gharbia", "Giza", "Ismailia", "Kafr El Sheikh", "Luxor", "Matruh", "Minya", "Monufia", "New Valley", "North Sinai", "Port Said", "Qalyubia", "Qena", "Red Sea", "Sharqia", "Sohag", "South Sinai", "Suez"],

  "Turkey": [ // Provinces of Turkey
    "Adana", "Ankara", "Antalya", "Aydın", "Bursa", "Edirne", "Erzurum", "Eskişehir", "Gaziantep", "Istanbul", "Izmir", "Kayseri", "Kocaeli", "Konya", "Mersin", "Samsun", "Trabzon", "Van"],

  "Iran": [ // Provinces of Iran
    "Alborz", "Ardabil", "Bushehr", "Chaharmahal and Bakhtiari", "East Azerbaijan", "Fars", "Gilan", "Golestan", "Hamadan", "Hormozgan", "Ilam", "Isfahan", "Kerman", "Kermanshah", "Khuzestan", "Kurdistan", "Lorestan", "Markazi", "Mazandaran", "Qazvin", "Qom", "Razavi Khorasan", "Semnan", "Sistan and Baluchestan", "Tehran", "West Azerbaijan", "Yazd", "Zanjan"],

  "Ukraine": [ // Oblasts of Ukraine
    "Cherkasy", "Chernihiv", "Chernivtsi", "Dnipropetrovsk", "Donetsk", "Ivano-Frankivsk", "Kharkiv", "Kherson", "Khmelnytskyi", "Kirovohrad", "Kyiv", "Luhansk", "Lviv", "Mykolaiv", "Odesa", "Poltava", "Rivne", "Sumy", "Ternopil", "Vinnytsia", "Volyn", "Zakarpattia", "Zaporizhzhia", "Zhytomyr"],

  "Poland": [ // Voivodeships of Poland
    "Greater Poland", "Kuyavian-Pomeranian", "Lesser Poland", "Łódź", "Lower Silesian", "Lublin", "Lubusz", "Masovian", "Opole", "Podkarpackie", "Podlaskie", "Pomeranian", "Silesian", "Świętokrzyskie", "Warmian-Masurian", "West Pomeranian"],

  "Portugal": [ // Regions of Portugal
    "Alentejo", "Algarve", "Azores", "Centro", "Lisbon", "Madeira", "Norte"],

  "Belgium": [ // Regions of Belgium
    "Brussels-Capital", "Flemish Region", "Walloon Region"],

  "Austria": [ // States of Austria
    "Burgenland", "Carinthia", "Lower Austria", "Upper Austria", "Salzburg", "Styria", "Tyrol", "Vorarlberg", "Vienna"],

  "Czech Republic": [ // Regions of Czech Republic
    "Central Bohemian", "South Bohemian", "Plzeň", "Karlovy Vary", "Ústí nad Labem",
    "Liberec", "Hradec Králové", "Pardubice", "Vysočina", "South Moravian",
    "Olomouc", "Zlín", "Moravian-Silesian", "Prague"
  ],

  "Greece": [ // Administrative regions of Greece
    "Attica", "Central Greece", "Central Macedonia", "Crete", "Eastern Macedonia and Thrace",
    "Epirus", "Ionian Islands", "North Aegean", "Peloponnese", "South Aegean",
    "Thessaly", "Western Greece", "Western Macedonia", "Mount Athos (Autonomous Monastic State)"
  ],

  "Hungary": [ // Counties of Hungary
    "Bács-Kiskun", "Baranya", "Békés", "Borsod-Abaúj-Zemplén", "Csongrád-Csanád",
    "Fejér", "Győr-Moson-Sopron", "Hajdú-Bihar", "Heves", "Jász-Nagykun-Szolnok",
    "Komárom-Esztergom", "Nógrád", "Pest", "Somogy", "Szabolcs-Szatmár-Bereg",
    "Tolna", "Vas", "Veszprém", "Zala", "Budapest (Capital City)"
  ],

  "Finland": [ // Regions of Finland
    "Åland", "Central Finland", "Central Ostrobothnia", "Kainuu", "Kymenlaakso",
    "Lapland", "North Karelia", "Northern Ostrobothnia", "Northern Savonia",
    "Ostrobothnia", "Päijät-Häme", "Pirkanmaa", "Satakunta", "South Karelia",
    "Southern Ostrobothnia", "Southern Savonia", "Uusimaa", "Varsinais-Suomi"
  ],

  "Ireland": [ // Provinces and counties of Ireland
    "Leinster", "Munster", "Connacht", "Ulster",
    "Carlow", "Cavan", "Clare", "Cork", "Donegal", "Dublin", "Galway", "Kerry",
    "Kildare", "Kilkenny", "Laois", "Leitrim", "Limerick", "Longford", "Louth",
    "Mayo", "Meath", "Monaghan", "Offaly", "Roscommon", "Sligo", "Tipperary",
    "Waterford", "Westmeath", "Wexford", "Wicklow"
  ],

  "Romania": [ // Counties of Romania
    "Alba", "Arad", "Argeș", "Bacău", "Bihor", "Bistrița-Năsăud", "Botoșani",
    "Brașov", "Brăila", "Buzău", "Călărași", "Caraș-Severin", "Cluj",
    "Constanța", "Covasna", "Dâmbovița", "Dolj", "Galați", "Giurgiu",
    "Gorj", "Harghita", "Hunedoara", "Ialomița", "Iași", "Ilfov",
    "Maramureș", "Mehedinți", "Mureș", "Neamț", "Olt", "Prahova",
    "Sălaj", "Satu Mare", "Sibiu", "Suceava", "Teleorman", "Timiș",
    "Tulcea", "Vâlcea", "Vaslui", "Vrancea", "Bucharest (Capital)"
  ],

  "Chile": [ // Regions of Chile
    "Arica and Parinacota", "Tarapacá", "Antofagasta", "Atacama", "Coquimbo",
    "Valparaíso", "Metropolitan", "O'Higgins", "Maule", "Ñuble",
    "Biobío", "Araucanía", "Los Ríos", "Los Lagos", "Aysén",
    "Magallanes and Chilean Antarctica"
  ],

  "Colombia": [ // Departments of Colombia
    "Amazonas", "Antioquia", "Arauca", "Atlántico", "Bolívar", "Boyacá", "Caldas",
    "Caquetá", "Casanare", "Cauca", "Cesar", "Chocó", "Córdoba", "Cundinamarca",
    "Guainía", "Guaviare", "Huila", "La Guajira", "Magdalena", "Meta",
    "Nariño", "Norte de Santander", "Putumayo", "Quindío", "Risaralda",
    "San Andrés and Providencia", "Santander", "Sucre", "Tolima", "Valle del Cauca",
    "Vaupés", "Vichada", "Bogotá (Capital District)"
  ],

  "Peru": [ // Regions of Peru
    "Amazonas", "Ancash", "Apurímac", "Arequipa", "Ayacucho", "Cajamarca", "Callao",
    "Cusco", "Huancavelica", "Huánuco", "Ica", "Junín", "La Libertad",
    "Lambayeque", "Lima", "Loreto", "Madre de Dios", "Moquegua",
    "Pasco", "Piura", "Puno", "San Martín", "Tacna", "Tumbes", "Ucayali"
  ],

  "Venezuela": [ // States of Venezuela
    "Amazonas", "Anzoátegui", "Apure", "Aragua", "Barinas", "Bolívar", "Carabobo",
    "Cojedes", "Delta Amacuro", "Falcón", "Guárico", "Lara", "Mérida",
    "Miranda", "Monagas", "Nueva Esparta", "Portuguesa", "Sucre", "Táchira",
    "Trujillo", "Vargas", "Yaracuy", "Zulia", "Distrito Capital"
  ],

  "Ecuador": [ // Provinces of Ecuador
    "Azuay", "Bolívar", "Cañar", "Carchi", "Chimborazo", "Cotopaxi",
    "El Oro", "Esmeraldas", "Galápagos", "Guayas", "Imbabura",
    "Loja", "Los Ríos", "Manabí", "Morona Santiago", "Napo",
    "Orellana", "Pastaza", "Pichincha", "Santa Elena", "Santo Domingo de los Tsáchilas",
    "Sucumbíos", "Tungurahua", "Zamora-Chinchipe"
  ],

  "Bolivia": [ // Departments of Bolivia
    "Beni", "Chuquisaca", "Cochabamba", "La Paz", "Oruro", "Pando",
    "Potosí", "Santa Cruz", "Tarija"
  ],

  "Paraguay": [ // Departments of Paraguay
    "Alto Paraguay", "Alto Paraná", "Amambay", "Boquerón", "Caaguazú",
    "Caazapá", "Canindeyú", "Central", "Concepción", "Cordillera",
    "Guairá", "Itapúa", "Misiones", "Ñeembucú", "Paraguarí",
    "Presidente Hayes", "San Pedro"
  ],

  "Uruguay": [ // Departments of Uruguay
    "Artigas", "Canelones", "Cerro Largo", "Colonia", "Durazno", "Flores",
    "Florida", "Lavalleja", "Maldonado", "Montevideo", "Paysandú",
    "Río Negro", "Rivera", "Rocha", "Salto", "San José",
    "Soriano", "Tacuarembó", "Treinta y Tres"
  ],

  "Cuba": [ // Provinces of Cuba
    "Artemisa", "Camagüey", "Ciego de Ávila", "Cienfuegos", "Granma",
    "Guantánamo", "Holguín", "La Habana", "Las Tunas", "Matanzas",
    "Mayabeque", "Pinar del Río", "Sancti Spíritus", "Santiago de Cuba", "Villa Clara"
  ],

  "Honduras": [ // Departments of Honduras
    "Atlántida", "Choluteca", "Colón", "Comayagua", "Copán", "Cortés", "El Paraíso",
    "Francisco Morazán", "Gracias a Dios", "Intibucá", "Islas de la Bahía",
    "La Paz", "Lempira", "Ocotepeque", "Olancho", "Santa Bárbara", "Valle", "Yoro"
  ],

  "Guatemala": [ // Departments of Guatemala
    "Alta Verapaz", "Baja Verapaz", "Chimaltenango", "Chiquimula", "El Progreso",
    "Escuintla", "Guatemala", "Huehuetenango", "Izabal", "Jalapa", "Jutiapa",
    "Quetzaltenango", "Quiché", "Retalhuleu", "Sacatepéquez", "San Marcos",
    "Santa Rosa", "Sololá", "Suchitepéquez", "Totonicapán", "Zacapa"
  ],

"El Salvador": [
    "Ahuachapán", "Cabañas", "Chalatenango", "Cuscatlán", "La Libertad",
    "La Paz", "La Unión", "Morazán", "San Miguel", "San Salvador",
    "San Vicente", "Santa Ana", "Sonsonate", "Usulután"
  ],
  "Panama": [
    "Bocas del Toro", "Coclé", "Colón", "Chiriquí", "Darién",
    "Herrera", "Los Santos", "Panamá", "Veraguas", "Guna Yala",
    "Emberá", "Ngäbe-Buglé"
  ],
  "Costa Rica": [
    "Alajuela", "Cartago", "Guanacaste", "Heredia", "Limón",
    "Puntarenas", "San José"
  ],
  "Jamaica": [
    "Clarendon", "Hanover", "Kingston", "Manchester", "Portland",
    "Saint Andrew", "Saint Ann", "Saint Catherine", "Saint Elizabeth",
    "Saint James", "Saint Mary", "Saint Thomas", "Trelawny", "Westmoreland"
  ],
  "Trinidad and Tobago": [
    "Arima", "Chaguanas", "Couva-Tabaquite-Talparo", "Diego Martin",
    "Mayaro-Rio Claro", "Penal-Debe", "Point Fortin", "Port of Spain",
    "Princes Town", "San Fernando", "San Juan-Laventille", "Sangre Grande",
    "Siparia", "Tunapuna-Piarco", "Tobago"
  ],
  "Bahamas": [
    "Acklins", "Berry Islands", "Bimini", "Black Point", "Cat Island",
    "Central Abaco", "Central Andros", "Central Eleuthera", "Crooked Island",
    "East Grand Bahama", "Exuma", "Grand Cay", "Harbour Island",
    "Hope Town", "Inagua", "Long Island", "Mangrove Cay", "Mayaguana",
    "Moore’s Island", "New Providence", "North Abaco", "North Andros",
    "North Eleuthera", "Ragged Island", "Rum Cay", "San Salvador",
    "South Abaco", "South Andros", "South Eleuthera", "Spanish Wells",
    "West Grand Bahama"
  ],
  "Barbados": [
    "Christ Church", "Saint Andrew", "Saint George", "Saint James",
    "Saint John", "Saint Joseph", "Saint Lucy", "Saint Michael",
    "Saint Peter", "Saint Philip", "Saint Thomas"
  ],
  "Iceland": [
    "Capital Region", "Southern Peninsula", "Western Region",
    "Westfjords", "Northwestern Region", "Northeastern Region",
    "Eastern Region", "Southern Region"
  ],
  "Malta": [
    "Attard", "Balzan", "Birgu", "Birkirkara", "Birżebbuġa",
    "Cospicua", "Dingli", "Fgura", "Floriana", "Fontana",
    "Għajnsielem", "Għarb", "Għargħur", "Għasri", "Għaxaq",
    "Gudja", "Gżira", "Ħamrun", "Iklin", "Isla", "Kalkara",
    "Kerċem", "Kirkop", "Lija", "Luqa", "Marsa", "Marsaskala",
    "Marsaxlokk", "Mdina", "Mellieħa", "Mġarr", "Mosta",
    "Mqabba", "Msida", "Mtarfa", "Munxar", "Nadur", "Naxxar",
    "Paola", "Pembroke", "Pietà", "Qala", "Qormi", "Qrendi",
    "Rabat", "Safi", "San Ġiljan", "San Lawrenz", "San Pawl il-Baħar",
    "Sannat", "Santa Luċija", "Santa Venera", "Siġġiewi",
    "Sliema", "Swieqi", "Ta' Xbiex", "Tarxien", "Valletta",
    "Xagħra", "Xewkija", "Xgħajra", "Żabbar", "Żebbuġ", "Żejtun", "Żurrieq"
  ],
  "Luxembourg": [
    "Canton of Capellen", "Canton of Clervaux", "Canton of Diekirch",
    "Canton of Echternach", "Canton of Esch-sur-Alzette", "Canton of Grevenmacher",
    "Canton of Luxembourg", "Canton of Mersch", "Canton of Redange",
    "Canton of Remich", "Canton of Vianden", "Canton of Wiltz"
  ],
  "Cyprus": [
    "Famagusta", "Kyrenia", "Larnaca", "Limassol", "Nicosia", "Paphos"
  ],
  "Estonia": [
    "Harju", "Hiiu", "Ida-Viru", "Jõgeva", "Järva",
    "Lääne", "Lääne-Viru", "Põlva", "Pärnu", "Rapla",
    "Saare", "Tartu", "Valga", "Viljandi", "Võru"
  ],
  "Latvia": [
    "Aglona", "Aizkraukle", "Aizpute", "Aknīste", "Aloja",
    "Alūksne", "Ape", "Auce", "Babīte", "Baldone", "Baltinava",
    "Balvi", "Bauska", "Beverīna", "Brocēni", "Burtnieki",
    "Carnikava", "Cesvaine", "Cēsis", "Cibla", "Dagda",
    "Daugavpils", "Dobele", "Dundaga", "Durbe", "Engure",
    "Ērgļi", "Garkalne", "Grobiņa", "Gulbene", "Iecava",
    "Ikšķile", "Ilūkste", "Inčukalns", "Jaunjelgava", "Jaunpiebalga",
    "Jaunpils", "Jelgava", "Jēkabpils", "Jūrmala", "Kandava",
    "Kārsava", "Ķegums", "Ķekava", "Kocēni", "Koknese",
    "Krāslava", "Krimulda", "Kuldīga", "Lielvārde", "Liepāja",
    "Limbaži", "Līgatne", "Līvāni", "Lubāna", "Ludza",
    "Madona", "Mazsalaca", "Mālpils", "Mārupe", "Mērsrags",
    "Naukšēni", "Nereta", "Nīca", "Ogre", "Olaine", "Ozolnieki",
    "Pārgauja", "Pāvilosta", "Pļaviņas", "Preiļi", "Priekule",
    "Priekuļi", "Rauna", "Rēzekne", "Rīga", "Rojas", "Ropaži",
    "Rucava", "Rugāji", "Rundāle", "Sala", "Salacgrīva",
    "Salaspils", "Saldus", "Saulkrasti", "Sigulda", "Skrīveri",
    "Skrunda", "Smiltene", "Stopiņi", "Strenči", "Talsi",
    "Tērvetes", "Tukums", "Vaiņode", "Valka", "Valmiera",
    "Vārkava", "Vecpiebalga", "Vecumnieki", "Ventspils",
    "Viesīte", "Viļaka", "Viļāni", "Zilupe"
  ],
  "Lithuania": [
    "Alytus", "Kaunas", "Klaipėda", "Marijampolė", "Panevėžys",
    "Šiauliai", "Tauragė", "Telšiai", "Utena", "Vilnius"
  ],
  "Croatia": [
    "Bjelovar-Bilogora", "Brod-Posavina", "Dubrovnik-Neretva",
    "Istria", "Karlovac", "Koprivnica-Križevci", "Krapina-Zagorje",
    "Lika-Senj", "Međimurje", "Osijek-Baranja", "Požega-Slavonia",
    "Primorje-Gorski Kotar", "Sisak-Moslavina", "Split-Dalmatia",
    "Varaždin", "Virovitica-Podravina", "Vukovar-Srijem", "Zadar",
    "Zagreb", "Zagreb City"
  ],
  "Slovakia": [
    "Banská Bystrica", "Bratislava", "Košice", "Nitra", 
    "Prešov", "Trenčín", "Trnava", "Žilina"
  ],
  "Slovenia": [
    "Ajdovščina", "Beltinci", "Benedikt", "Bistrica ob Sotli", "Bled", 
    "Bloke", "Bohinj", "Borovnica", "Bovec", "Braslovče", 
    "Brda", "Brezovica", "Brežice", "Cankova", "Celje", 
    "Cerklje na Gorenjskem", "Cerknica", "Cerkno", "Cirkulane", "Črenšovci",
    "Črna na Koroškem", "Črnomelj", "Destrnik", "Divača", "Dobje",
    "Dobrepolje", "Dobrna", "Dobrova-Polhov Gradec", "Dol pri Ljubljani", "Dolenjske Toplice",
    "Domžale", "Dornava", "Dravograd", "Duplek", "Gorenja vas-Poljane",
    "Gorišnica", "Gornja Radgona", "Gornji Grad", "Gornji Petrovci", "Grad",
    "Grosuplje", "Hajdina", "Hoče-Slivnica", "Hodoš", "Horjul",
    "Hrastnik", "Hrpelje-Kozina", "Idrija", "Ig", "Ilirska Bistrica",
    "Ivančna Gorica", "Izola", "Jesenice", "Juršinci", "Kamnik",
    "Kanal", "Kidričevo", "Kobarid", "Kobilje", "Kočevje",
    "Komen", "Komenda", "Koper", "Kostanjevica na Krki", "Kostel",
    "Kozje", "Kranj", "Kranjska Gora", "Križevci", "Kungota",
    "Kuzma", "Laško", "Lenart", "Lendava", "Litija",
    "Ljubljana", "Ljubno", "Ljutomer", "Log-Dragomer", "Logatec",
    "Loška Dolina", "Loški Potok", "Lukovica", "Majšperk", "Makole",
    "Maribor", "Markovci", "Medvode", "Mengeš", "Metlika",
    "Mežica", "Miren-Kostanjevica", "Mirna Peč", "Mislinja", "Moravče",
    "Moravske Toplice", "Mozirje", "Murska Sobota", "Muta", "Naklo",
    "Nazarje", "Nova Gorica", "Novo Mesto", "Odranci", "Ormož",
    "Osilnica", "Pesnica", "Piran", "Pivka", "Podčetrtek",
    "Podlehnik", "Podvelka", "Postojna", "Prebold", "Preddvor",
    "Prevalje", "Ptuj", "Puconci", "Rače-Fram", "Radeče",
    "Radenci", "Radlje ob Dravi", "Radovljica", "Ravne na Koroškem", "Razkrižje",
    "Rečica ob Savinji", "Renče-Vogrsko", "Ribnica", "Rogaška Slatina", "Rogašovci",
    "Rogatec", "Ruše", "Semič", "Sevnica", "Sežana",
    "Slovenj Gradec", "Slovenska Bistrica", "Slovenske Konjice", "Šalovci", "Šempeter-Vrtojba",
    "Šenčur", "Šentilj", "Šentjernej", "Šentjur", "Šentrupert",
    "Škocjan", "Škofja Loka", "Škofljica", "Šmarje pri Jelšah", "Šmarješke Toplice",
    "Šmartno ob Paki", "Šoštanj", "Štore", "Tolmin", "Trbovlje",
    "Trebnje", "Tržič", "Turnišče", "Velenje", "Velika Polana",
    "Veržej", "Videm", "Vipava", "Vitanje", "Vodice",
    "Vojnik", "Vransko", "Vrhnika", "Vuzenica", "Zagorje ob Savi",
    "Žalec", "Železniki", "Žetale", "Žiri", "Žirovnica",
    "Žužemberk"
  ],
  "Bulgaria": [
    "Blagoevgrad", "Burgas", "Dobrich", "Gabrovo", "Haskovo", 
    "Kardzhali", "Kyustendil", "Lovech", "Montana", "Pazardzhik", 
    "Pernik", "Pleven", "Plovdiv", "Razgrad", "Ruse", 
    "Shumen", "Silistra", "Sliven", "Smolyan", "Sofia", 
    "Sofia City", "Stara Zagora", "Targovishte", "Varna", "Veliko Tarnovo", 
    "Vidin", "Vratsa", "Yambol"
  ],
  "Serbia": [
    "Belgrade", "Bor", "Braničevo", "Central Banat", "Jablanica", 
    "Kolubara", "Mačva", "Morava", "Nišava", "North Bačka", 
    "North Banat", "Pčinja", "Pirot", "Pomoravlje", "Rasina", 
    "Raška", "South Bačka", "South Banat", "Srem", "Šumadija", 
    "Toplica", "West Bačka", "Zaječar", "Zlatibor"
  ],
  "Montenegro": [
    "Andrijevica", "Bar", "Berane", "Bijelo Polje", "Budva", 
    "Cetinje", "Danilovgrad", "Gusinje", "Herceg Novi", "Kolašin", 
    "Kotor", "Mojkovac", "Nikšić", "Petnjica", "Plav", 
    "Pljevlja", "Plužine", "Podgorica", "Rožaje", "Šavnik", 
    "Tivat", "Tuzi", "Ulcinj", "Žabljak"
  ],
  "Albania": [
    "Berat", "Dibër", "Durrës", "Elbasan", "Fier", 
    "Gjirokastër", "Korçë", "Kukës", "Lezhë", "Shkodër", 
    "Tirana", "Vlorë"
  ],
  "North Macedonia": [
    "Aerodrom", "Berovo", "Bitola", "Bogdanci", "Bogovinje", 
    "Bosilovo", "Brvenica", "Centar", "Čair", "Debar", 
    "Demir Hisar", "Demir Kapija", "Delčevo", "Gevgelija", "Gostivar", 
    "Karpoš", "Kavadarci", "Kičevo", "Kočani", "Kumanovo", 
    "Ohrid", "Prilep", "Radoviš", "Štip", "Struga", 
    "Strumica", "Tetovo", "Veles", "Vinica"
  ],
  Afghanistan: [
    "Badakhshan", "Badghis", "Baghlan", "Balkh", "Bamyan", "Daykundi", "Farah", "Faryab", "Ghazni", "Ghor",
    "Helmand", "Herat", "Jowzjan", "Kabul", "Kandahar", "Kapisa", "Khost", "Kunar", "Kunduz", "Laghman",
    "Logar", "Maidan Wardak", "Nangarhar", "Nimroz", "Nuristan", "Paktia", "Paktika", "Panjshir", "Parwan",
    "Samangan", "Sar-e Pol", "Takhar", "Urozgan", "Zabul"
    ],
    
    Bhutan: [
    "Bumthang", "Chhukha", "Dagana", "Gasa", "Haa", "Lhuntse", "Mongar", "Paro", "Pemagatshel", "Punakha",
    "Samdrup Jongkhar", "Samtse", "Sarpang", "Thimphu", "Trashigang", "Trashiyangtse", "Trongsa", "Tsirang",
    "Wangdue Phodrang", "Zhemgang"
    ],
    
    Maldives: [
    "Alifu Alifu", "Alifu Dhaalu", "Baa", "Dhaalu", "Faafu", "Gaafu Alifu", "Gaafu Dhaalu", "Gnaviyani",
    "Haa Alifu", "Haa Dhaalu", "Kaafu", "Laamu", "Lhaviyani", "Meemu", "Noonu", "Raa", "Seenu", "Shaviyani",
    "Thaa", "Vaavu"
    ],
    
    Nepal: [
    "Province No. 1", "Madhesh Province", "Bagmati Province", "Gandaki Province", "Lumbini Province",
    "Karnali Province", "Sudurpashchim Province"
    ],
    
    Mongolia: [
    "Arkhangai", "Bayan-Ölgii", "Bayankhongor", "Bulgan", "Darkhan-Uul", "Dornod", "Dornogovi", "Dundgovi",
    "Govi-Altai", "Govisümber", "Khentii", "Khovd", "Khövsgöl", "Ömnögovi", "Orkhon", "Övörkhangai",
    "Selenge", "Sükhbaatar", "Töv", "Uvs", "Zavkhan", "Ulaanbaatar"
    ],
    
    Taiwan: [
    "Changhua", "Chiayi", "Hsinchu", "Hualien", "Kaohsiung", "Keelung", "Kinmen", "Lienchiang", "Miaoli",
    "Nantou", "New Taipei", "Penghu", "Pingtung", "Taichung", "Tainan", "Taipei", "Taitung", "Taoyuan",
    "Yilan", "Yunlin"
    ],
    
    Brunei: [
    "Belait", "Brunei-Muara", "Temburong", "Tutong"
    ],
    
    Cambodia: [
    "Banteay Meanchey", "Battambang", "Kampong Cham", "Kampong Chhnang", "Kampong Speu", "Kampong Thom",
    "Kampot", "Kandal", "Koh Kong", "Kratie", "Mondulkiri", "Oddar Meanchey", "Pailin", "Phnom Penh",
    "Preah Vihear", "Prey Veng", "Pursat", "Ratanakiri", "Siem Reap", "Sihanoukville", "Stung Treng",
    "Svay Rieng", "Takeo", "Tbong Khmum"
    ],
    
    Laos: [
    "Attapeu", "Bokeo", "Bolikhamsai", "Champasak", "Houaphanh", "Khammouane", "Luang Namtha", "Luang Prabang",
    "Oudomxay", "Phongsaly", "Salavan", "Savannakhet", "Vientiane", "Xaignabouli", "Xekong", "Xiangkhouang"
    ],
    
    "Myanmar (Burma)": [
    "Ayeyarwady", "Bago", "Chin", "Kachin", "Kayah", "Kayin", "Magway", "Mandalay", "Mon", "Naypyidaw",
    "Rakhine", "Sagaing", "Shan", "Tanintharyi", "Yangon"
    ],
    
    "Timor-Leste": [
    "Aileu", "Ainaro", "Baucau", "Bobonaro", "Cova Lima", "Dili", "Ermera", "Lautém", "Liquiça", "Manatuto",
    "Manufahi", "Oecusse", "Viqueque"
    ],
    
    Iraq: [
    "Al Anbar", "Al Muthanna", "Al Qadisiyyah", "Babylon", "Baghdad", "Basra", "Dhi Qar", "Diyala", "Dohuk",
    "Erbil", "Karbala", "Kirkuk", "Maysan", "Najaf", "Nineveh", "Saladin", "Sulaymaniyah", "Wasit"
    ],
    
    Jordan: [
    "Ajloun", "Amman", "Aqaba", "Balqa", "Irbid", "Jerash", "Karak", "Ma'an", "Madaba", "Mafraq", "Tafilah", "Zarqa"
    ],
    
    Kuwait: [
    "Al Ahmadi", "Al Farwaniyah", "Al Jahra", "Capital", "Hawalli", "Mubarak Al-Kabeer"
    ],
    
    Lebanon: [
    "Akkar", "Baalbek-Hermel", "Beirut", "Beqaa", "Mount Lebanon", "North Lebanon", "South Lebanon", "Nabatieh"
    ],
    
    Oman: [
    "Ad Dakhiliyah", "Ad Dhahirah", "Al Batinah North", "Al Batinah South", "Al Buraimi", "Al Wusta", "Ash Sharqiyah North",
    "Ash Sharqiyah South", "Dhofar", "Muscat", "Musandam"
    ],
    
    Palestine: [
    "Bethlehem", "Deir al-Balah", "Gaza", "Hebron", "Jenin", "Jericho", "Jerusalem", "Khan Yunis", "Nablus",
    "North Gaza", "Qalqilya", "Rafah", "Ramallah and al-Bireh", "Salfit", "Tubas", "Tulkarm"
    ],
    
    Syria: [
    "Al-Hasakah", "Aleppo", "Ar-Raqqah", "As-Suwayda", "Daraa", "Deir ez-Zor", "Hama", "Homs", "Idlib",
    "Latakia", "Quneitra", "Rif Dimashq", "Tartus"
    ],
    
    Yemen: [
    "Abyan", "Aden", "Al Bayda", "Al Hudaydah", "Al Jawf", "Al Mahrah", "Al Mahwit", "Amran", "Dhamar",
    "Hadhramaut", "Hajjah", "Ibb", "Lahij", "Ma'rib", "Raymah", "Sa'dah", "Sana'a", "Shabwah", "Socotra", "Ta'izz"
    ],

    "Andorra": [
    "Andorra la Vella", "Canillo", "Encamp", "Escaldes-Engordany", "La Massana", "Ordino", "Sant Julià de Lòria"
  ],
  "Belarus": [
    "Brest Region", "Gomel Region", "Grodno Region", "Minsk Region", "Mogilev Region", "Vitebsk Region"
  ],
  "Bosnia and Herzegovina": [
    "Federation of Bosnia and Herzegovina", "Republika Srpska", "Brčko District"
  ],
  "Liechtenstein": [
    "Balzers", "Eschen", "Gamprin", "Mauren", "Planken", "Ruggell", "Schaan", "Schellenberg", "Triesen", "Triesenberg", "Vaduz"
  ],
  "Moldova": [
    "Anenii Noi", "Basarabeasca", "Briceni", "Cahul", "Cantemir", "Călărași", "Cimișlia", "Criuleni", "Dondușeni", "Drochia", 
    "Dubăsari", "Edineț", "Fălești", "Florești", "Glodeni", "Hîncești", "Ialoveni", "Leova", "Nisporeni", "Ocnița", "Orhei", 
    "Rezina", "Rîșcani", "Sîngerei", "Soroca", "Strășeni", "Șoldănești", "Ștefan Vodă", "Taraclia", "Telenești", "Ungheni", 
    "Găgăuzia (Autonomous Territorial Unit)", "Chișinău (Municipality)", "Bender (Municipality)", "Tiraspol (Municipality)"
  ],
  Monaco: [
    "La Condamine", "Fontvieille", "Jardin Exotique", "Larvotto", "Monaco-Ville", "Monte Carlo", "Moneghetti", "Port-Hercule", "Saint Michel"
  ],
  "San Marino": [
    "Acquaviva", "Borgo Maggiore", "Chiesanuova", "Domagnano", "Faetano", "Fiorentino", "Montegiardino", "San Marino", "Serravalle"
  ],
  "Vatican City": [
    "Vatican City (entire country is a single entity with no subdivisions)"
  ],
   
  "Antigua and Barbuda": [
    "Barbuda", "Redonda", "Saint George", "Saint John", "Saint Mary", "Saint Paul", "Saint Peter", "Saint Philip"
  ],
  "Belize": [
    "Belize", "Cayo", "Corozal", "Orange Walk", "Stann Creek", "Toledo"
  ],
  "Dominica": [
    "Saint Andrew", "Saint David", "Saint George", "Saint John", "Saint Joseph", "Saint Luke", 
    "Saint Mark", "Saint Patrick", "Saint Paul", "Saint Peter"
  ],
  "Dominican Republic": [
    "Azua", "Baoruco", "Barahona", "Dajabón", "Distrito Nacional", "Duarte", "El Seibo", "Elías Piña", 
    "Espaillat", "Hato Mayor", "Hermanas Mirabal", "Independencia", "La Altagracia", "La Romana", 
    "La Vega", "María Trinidad Sánchez", "Monseñor Nouel", "Monte Cristi", "Monte Plata", "Pedernales", 
    "Peravia", "Puerto Plata", "Samaná", "San Cristóbal", "San José de Ocoa", "San Juan", "San Pedro de Macorís", 
    "Sánchez Ramírez", "Santiago", "Santiago Rodríguez", "Santo Domingo", "Valverde"
  ],
  "Grenada": [
    "Saint Andrew", "Saint David", "Saint George", "Saint John", "Saint Mark", "Saint Patrick", "Carriacou and Petite Martinique"
  ],
  "Haiti": [
    "Artibonite", "Centre", "Grand'Anse", "Nippes", "Nord", "Nord-Est", "Nord-Ouest", "Ouest", "Sud", "Sud-Est"
  ],
  "Nicaragua": [
    "Boaco", "Carazo", "Chinandega", "Chontales", "Estelí", "Granada", "Jinotega", "León", 
    "Madriz", "Managua", "Masaya", "Matagalpa", "Nueva Segovia", "Río San Juan", "Rivas", 
    "North Caribbean Coast", "South Caribbean Coast"
  ],
  "Saint Kitts and Nevis": [
    "Christ Church Nichola Town", "Saint Anne Sandy Point", "Saint George Basseterre", "Saint George Gingerland", 
    "Saint James Windward", "Saint John Capisterre", "Saint John Figtree", "Saint Mary Cayon", "Saint Paul Capisterre", 
    "Saint Paul Charlestown", "Saint Peter Basseterre", "Saint Thomas Lowland", "Saint Thomas Middle Island", "Trinity Palmetto Point"
  ],
  "Saint Lucia": [
    "Anse la Raye", "Canaries", "Castries", "Choiseul", "Dennery", "Gros Islet", "Laborie", "Micoud", "Soufrière", "Vieux Fort"
  ],
  "Saint Vincent and the Grenadines": [
    "Charlotte", "Grenadines", "Saint Andrew", "Saint David", "Saint George", "Saint Patrick"
  ],

"Guyana": [
    "Barima-Waini", "Cuyuni-Mazaruni", "Demerara-Mahaica", "East Berbice-Corentyne", "Essequibo Islands-West Demerara",
    "Mahaica-Berbice", "Pomeroon-Supenaam", "Potaro-Siparuni", "Upper Demerara-Berbice", "Upper Takutu-Upper Essequibo" ],
  "Suriname": [
    "Brokopondo", "Commewijne", "Coronie", "Marowijne", "Nickerie", "Para", "Paramaribo", "Saramacca", "Sipaliwini", "Wanica"
  ],
  "French Guiana": ["Cayenne", "Saint-Laurent-du-Maroni", "Kourou", "Mana", "Matoury","Rémire-Montjoly", "Macouria", "Maripasoula", "Grand-Santi", "Apatou"],

"Algeria": [
    "Adrar", "Aïn Defla", "Aïn Témouchent", "Algiers", "Annaba", "Batna", "Béchar", "Béjaïa", "Biskra", "Blida", "Bordj Bou Arréridj", "Bouira", "Boumerdès", "Chlef", "Constantine", "Djelfa", "El Bayadh", "El Oued", "El Tarf", "Ghardaïa", "Guelma", "Illizi", "Jijel", "Khenchela", "Laghouat", "Mascara", "Médéa", "Mila", "Mostaganem", "Msila", "Naâma", 
    "Oran", "Ouargla", "Oum El Bouaghi", "Relizane", "Saïda", "Sétif", "Sidi Bel Abbès", "Skikda", "Souk Ahras", "Tamanghasset", "Tébessa", "Tiaret", "Tindouf", "Tipaza", "Tissemsilt", "Tizi Ouzou", "Tlemcen"],
  "Libya": [
    "Tripoli", "Benghazi", "Misrata", "Al Jufra", "Al Kufrah", "Al Marj", "Al Wahat", "Derna", "Ghat", "Jabal al Akhdar", "Jabal al Gharbi", "Jafara", "Jufra", "Marzuq", "Murqub", "Nalut", "Nuqat al Khams", "Sabha", "Sirte", "Wadi al Hayaa", "Wadi al Shatii", "Zawiya"
  ],
  "Morocco": [
    "Agadir-Ida Ou Tanane", "Al Haouz", "Al Hoceïma", "Aousserd", "Assa-Zag", "Azilal", "Béni Mellal", "Benslimane", "Berkane", "Berrechid", "Boujdour", "Boulemane", "Casablanca", 
    "Chefchaouen", "Chichaoua", "Driouch", "El Hajeb", "El Jadida", "Errachidia", "Es-Semara", "Essaouira", "Fahs-Anjra", "Fès", "Figuig", "Guelmim", "Ifrane", "Jerada", "Kelaat Sraghna", 
    "Kénitra", "Khémisset", "Khénifra", "Khouribga", "Laâyoune", "Larache", "Marrakech", "Meknès", "Midelt", "Mohammadia", "Nador", "Nouaceur", "Ouarzazate", "Oued Ed-Dahab", "Oujda-Angad", "Rabat", "Safi", "Salé", "Sefrou", "Settat", "Sidi Bennour", "Sidi Ifni", 
    "Skhirate-Témara", "Tanger-Assilah", "Tan-Tan", "Taounate", "Taourirt", "Tarfaya", "Taroudant", "Tata", "Taza", "Tétouan", "Tinghir", "Youssoufia", "Zagora"],
  "Sudan": [
    "Al Jazirah", "Al Qadarif", "Blue Nile", "Central Darfur", "East Darfur", "Kassala", "Khartoum", "North Darfur", "North Kordofan", "Northern", "Red Sea", "River Nile", "Sennar", "South Darfur", "South Kordofan", "West Darfur", "West Kordofan", "White Nile"],
  "Tunisia": [
    "Ariana", "Beja", "Ben Arous", "Bizerte", "Gabès", "Gafsa", "Jendouba", "Kairouan", "Kasserine", "Kebili", "La Manouba", "Le Kef", "Mahdia", "Medenine", "Monastir", "Nabeul", "Sfax", "Sidi Bouzid", "Siliana", "Sousse", "Tataouine", "Tozeur", "Tunis", "Zaghouan"],
  "Western Sahara (Disputed Territory)": ["Boujdour", "Es-Semara", "Laâyoune", "Oued Ed-Dahab", "Tarfaya"],
  "Benin": [
    "Alibori", "Atakora", "Atlantique", "Borgou", "Collines", "Donga", "Kouffo", "Littoral", "Mono", "Ouémé", "Plateau", "Zou"],
  "Burkina Faso": [
    "Boucle du Mouhoun", "Cascades", "Centre", "Centre-Est", "Centre-Nord", "Centre-Ouest", "Centre-Sud", "Est", "Hauts-Bassins", "Nord", "Plateau-Central", "Sahel", "Sud-Ouest"],
  "Cape Verde": ["Barlavento Islands", "Sotavento Islands"],
  "Côte d'Ivoire (Ivory Coast)": [
    "Abidjan", "Bas-Sassandra", "Comoé", "Denguélé", "Gôh-Djiboua", "Lacs", "Lagunes", "Montagnes", "Sassandra-Marahoué", "Savanes", "Vallée du Bandama", "Woroba", "Yamoussoukro", "Zanzan"],
  "The Gambia": [
    "Banjul", "Central River", "Lower River", "North Bank", "Upper River", "West Coast"],
  "Ghana": [
    "Ahafo", "Ashanti", "Bono", "Bono East", "Central", "Eastern", "Greater Accra", "North East", "Northern", "Oti", "Savannah", "Upper East", "Upper West", "Volta", "Western", "Western North"],
  "Guinea": [
    "Beyla", "Boffa", "Boké", "Conakry", "Coyah", "Dabola", "Dalaba", "Dinguiraye", "Dubréka", "Faranah", 
    "Forécariah", "Fria", "Gaoual", "Guéckédou", "Kankan", "Kérouané", "Kindia", "Kissidougou", "Koubia", 
    "Koundara", "Kouroussa", "Labé", "Lélouma", "Lola", "Macenta", "Mali", "Mamou", "Mandiana", "Nzérékoré", 
    "Pita", "Siguiri", "Télimélé", "Tougué", "Yomou"
  ],
  "Guinea-Bissau": [
    "Bafatá", "Biombo", "Bolama", "Cacheu", "Gabú", "Oio", "Quinara", "Tombali", "Sector Autónomo de Bissau"
  ],
  "Liberia": [
    "Bomi", "Bong", "Gbarpolu", "Grand Bassa", "Grand Cape Mount", "Grand Gedeh", "Grand Kru", "Lofa", "Margibi", "Maryland", "Montserrado", "Nimba", "River Cess", "River Gee", "Sinoe"],
  "Mali": [
    "Bamako", "Gao", "Kayes", "Kidal", "Koulikoro", "Ménaka", "Mopti", "Ségou", "Sikasso", "Taoudénit", "Tombouctou"
  ],
  "Mauritania": [
    "Adrar", "Assaba", "Brakna", "Dakhlet Nouadhibou", "Gorgol", "Guidimaka", "Hodh Ech Chargui", 
    "Hodh El Gharbi", "Inchiri", "Nouakchott-Nord", "Nouakchott-Ouest", "Nouakchott-Sud", "Tagant", "Tiris Zemmour", "Trarza"],
  "Niger": [
    "Agadez", "Diffa", "Dosso", "Maradi", "Niamey", "Tahoua", "Tillabéri", "Zinder"],
  "Nigeria": [
    "Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Bayelsa", "Benue", "Borno", "Cross River", 
    "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu", "FCT (Abuja)", "Gombe", "Imo", "Jigawa", "Kaduna", 
    "Kano", "Katsina", "Kebbi", "Kogi", "Kwara", "Lagos", "Nasarawa", "Niger", "Ogun", "Ondo", "Osun", 
    "Oyo", "Plateau", "Rivers", "Sokoto", "Taraba", "Yobe", "Zamfara"
  ],
  "Senegal": [
    "Dakar", "Diourbel", "Fatick", "Kaffrine", "Kaolack", "Kédougou", "Kolda", "Louga", "Matam", 
    "Saint-Louis", "Sédhiou", "Tambacounda", "Thiès", "Ziguinchor"],
  "Sierra Leone": [
    "Eastern", "Northern", "North Western", "Southern", "Western Area (Rural)", "Western Area (Urban)"],
  "Togo": [
    "Centrale", "Kara", "Maritime", "Plateaux", "Savanes"],
  "Angola": [
    "Bengo", "Benguela", "Bié", "Cabinda", "Cuando Cubango", "Cuanza Norte", "Cuanza Sul", 
    "Cunene", "Huambo", "Huíla", "Luanda", "Lunda Norte", "Lunda Sul", "Malanje", 
    "Moxico", "Namibe", "Uíge", "Zaire"],
  "Cameroon": [
    "Adamawa", "Centre", "East", "Far North", "Littoral", "North", "Northwest", 
    "South", "Southwest", "West"],
  "Central African Republic": [
    "Bamingui-Bangoran", "Basse-Kotto", "Haute-Kotto", "Haut-Mbomou", "Kémo", "Lobaye", 
    "Mambéré-Kadéï", "Mbomou", "Nana-Grébizi", "Nana-Mambéré", "Ombella-M'Poko", "Ouaka", "Ouham", "Ouham-Pendé", "Sangha-Mbaéré", "Vakaga", "Bangui (Capital)"],
  "Chad": [
    "Bahr el Gazel", "Batha", "Borkou", "Ennedi-Est", "Ennedi-Ouest", "Guéra", 
    "Hadjer-Lamis", "Kanem", "Lac", "Logone Occidental", "Logone Oriental", 
    "Mandoul", "Mayo-Kebbi Est", "Mayo-Kebbi Ouest", "Moyen-Chari", "Ouaddaï", 
    "Salamat", "Sila", "Tandjilé", "Tibesti", "Wadi Fira", "N'Djamena (Capital)"
  ],
  "Democratic Republic of the Congo": [
    "Bas-Uélé", "Haut-Uélé", "Ituri", "Tshopo", "Haut-Lomami", "Haut-Katanga", "Lomami", 
    "Lualaba", "Kasai", "Kasai-Central", "Kasai-Oriental", "Kwango", "Kwilu", 
    "Mai-Ndombe", "Mongala", "Nord-Ubangi", "Sud-Ubangi", "Équateur", "Tshuapa", 
    "Maniema", "Nord-Kivu", "Sud-Kivu", "Tanganyika", "Kinshasa (Capital)"
  ],
  "Republic of the Congo": [
    "Bouenza", "Cuvette", "Cuvette-Ouest", "Kouilou", "Lékoumou", "Likouala", 
    "Niari", "Plateaux", "Pointe-Noire", "Pool", "Sangha", "Brazzaville (Capital)"
  ],
  "Equatorial Guinea": [
    "Annobón", "Bioko Norte", "Bioko Sur", "Centro Sur", "Djibloho", "Kié-Ntem", 
    "Litoral", "Wele-Nzas"
  ],
  "Gabon": [
    "Estuaire", "Haut-Ogooué", "Moyen-Ogooué", "Ngounié", "Nyanga", "Ogooué-Ivindo", 
    "Ogooué-Lolo", "Ogooué-Maritime", "Woleu-Ntem"
  ],
  "São Tomé and Príncipe": [
    "Príncipe", "São Tomé"
  ],
  "Burundi": [
    "Bubanza", "Bujumbura Mairie", "Bujumbura Rural", "Bururi", "Cankuzo", "Cibitoke", 
    "Gitega", "Karuzi", "Kayanza", "Kirundo", "Makamba", "Muramvya", "Muyinga", 
    "Mwaro", "Ngozi", "Rumonge", "Rutana", "Ruyigi"
  ],
  "Comoros": [
    "Anjouan", "Grande Comore", "Mohéli"],
  "Djibouti": [
    "Ali Sabieh", "Arta", "Dikhil", "Djibouti", "Obock", "Tadjourah"],
  "Eritrea": [
    "Anseba", "Debub", "Debubawi Keyih Bahri", "Gash-Barka", "Maekel", "Semenawi Keyih Bahri"],
  "Ethiopia": [
    "Addis Ababa", "Afar", "Amhara", "Benishangul-Gumuz", "Dire Dawa", "Gambela", 
    "Harari", "Oromia", "Sidama", "Somali", "Southern Nations, Nationalities, and Peoples' Region", "Tigray"],
  "Kenya": [
    "Baringo", "Bomet", "Bungoma", "Busia", "Elgeyo-Marakwet", "Embu", "Garissa", 
    "Homa Bay", "Isiolo", "Kajiado", "Kakamega", "Kericho", "Kiambu", "Kilifi", 
    "Kirinyaga", "Kisii", "Kisumu", "Kitui", "Kwale", "Laikipia", "Lamu", "Machakos", 
    "Makueni", "Mandera", "Marsabit", "Meru", "Migori", "Mombasa", "Murang'a", "Nairobi", 
    "Nakuru", "Nandi", "Narok", "Nyamira", "Nyandarua", "Nyeri", "Samburu", "Siaya", 
    "Taita-Taveta", "Tana River", "Tharaka-Nithi", "Trans Nzoia", "Turkana", "Uasin Gishu", 
    "Vihiga", "Wajir", "West Pokot"
  ],
  "Madagascar": [
    "Alaotra-Mangoro", "Amoron'i Mania", "Analamanga", "Analanjirofo", "Androy", 
    "Anosy", "Atsimo-Andrefana", "Atsimo-Atsinanana", "Atsinanana", "Betsiboka", 
    "Boeny", "Bongolava", "Diana", "Haute Matsiatra", "Ihorombe", "Itasy", 
    "Melaky", "Menabe", "Sava", "Sofia", "Vakinankaratra", "Vatovavy-Fitovinany"
  ],
  "Malawi": [
    "Balaka", "Blantyre", "Chikwawa", "Chiradzulu", "Chitipa", "Dedza", "Dowa", 
    "Karonga", "Kasungu", "Likoma", "Lilongwe", "Machinga", "Mangochi", "Mchinji", 
    "Mulanje", "Mwanza", "Mzimba", "Neno", "Nkhata Bay", "Nkhotakota", "Nsanje", 
    "Ntcheu", "Ntchisi", "Phalombe", "Rumphi", "Salima", "Thyolo", "Zomba"
  ],
  "Mauritius": [
    "Agalega", "Black River", "Flacq", "Grand Port", "Moka", "Pamplemousses", 
    "Plaines Wilhems", "Port Louis", "Rivière du Rempart", "Rodrigues", "Savanne"
  ],
  "Mozambique": [
    "Cabo Delgado", "Gaza", "Inhambane", "Manica", "Maputo", "Maputo City", "Nampula", 
    "Niassa", "Sofala", "Tete", "Zambézia"
  ],
  "Rwanda": [
    "Eastern Province", "Kigali", "Northern Province", "Southern Province", "Western Province"
  ],
  "Seychelles": [
    "Anse Boileau", "Anse Royale", "Anse-aux-Pins", "Baie Lazare", "Baie Sainte Anne", 
    "Beau Vallon", "Bel Air", "Bel Ombre", "Cascade", "English River", "Glacis", 
    "Grand Anse Mahe", "Grand Anse Praslin", "La Digue", "La Rivière Anglaise", 
    "Mont Buxton", "Mont Fleuri", "Plaisance", "Pointe La Rue", "Port Glaud", 
    "Saint Louis", "Takamaka"
  ],
  "Somalia": [
    "Awdal", "Bakool", "Banaadir", "Bari", "Bay", "Galguduud", "Gedo", "Hiran", 
    "Lower Juba", "Lower Shabelle", "Middle Juba", "Middle Shabelle", "Mudug", 
    "Nugaal", "Sanaag", "Sool", "Togdheer", "Woqooyi Galbeed"
  ],
  "South Sudan": [
    "Central Equatoria", "Eastern Equatoria", "Jonglei", "Lakes", "Northern Bahr el Ghazal", 
    "Unity", "Upper Nile", "Warrap", "Western Bahr el Ghazal", "Western Equatoria"
  ],
  "Tanzania": [
    "Arusha", "Dar es Salaam", "Dodoma", "Geita", "Iringa", "Kagera", "Katavi", 
    "Kigoma", "Kilimanjaro", "Lindi", "Manyara", "Mara", "Mbeya", "Morogoro", 
    "Mtwara", "Mwanza", "Njombe", "Pemba North", "Pemba South", "Pwani", "Rukwa", 
    "Ruvuma", "Shinyanga", "Simiyu", "Singida", "Tabora", "Tanga", "Zanzibar North", 
    "Zanzibar South", "Zanzibar West"
  ],
  "Uganda": [
    "Abim", "Adjumani", "Agago", "Alebtong", "Amolatar", "Amudat", "Amuria", 
    "Amuru", "Apac", "Arua", "Budaka", "Bududa", "Bugiri", "Buhweju", "Buikwe", 
    "Bukedea", "Bukomansimbi", "Bukwo", "Bulambuli", "Buliisa", "Bundibugyo", 
    "Bushenyi", "Busia", "Butaleja", "Butambala", "Buvuma", "Buyende", "Dokolo", 
    "Gomba", "Gulu", "Hoima", "Ibanda", "Iganga", "Isingiro", "Jinja", "Kaabong", 
    "Kabale", "Kabarole", "Kaberamaido", "Kalangala", "Kaliro", "Kalungu", "Kampala", 
    "Kamuli", "Kamwenge", "Kanungu", "Kapchorwa", "Kasese", "Katakwi", "Kayunga", 
    "Kibaale", "Kiboga", "Kibuku", "Kiruhura", "Kiryandongo", "Kisoro", "Kitgum", 
    "Koboko", "Kole", "Kotido", "Kumi", "Kween", "Kyankwanzi", "Kyegegwa", "Kyenjojo", 
    "Lamwo", "Lira", "Luuka", "Luwero", "Lwengo", "Lyantonde", "Manafwa", "Maracha", 
    "Masaka", "Masindi", "Mayuge", "Mbale", "Mbarara", "Mitooma", "Mityana", 
    "Moroto", "Moyo", "Mpigi", "Mubende", "Mukono", "Nakapiripirit", "Nakasongola", 
    "Namutumba", "Napak", "Nebbi", "Ngora", "Ntoroko", "Ntungamo", "Nwoya", "Otuke", 
    "Oyam", "Pader", "Pallisa", "Rakai", "Rubirizi", "Rukungiri", "Serere", 
    "Sheema", "Sironko", "Soroti", "Tororo", "Wakiso", "Yumbe", "Zombo"
  ],
  "Zambia": [
    "Central", "Copperbelt", "Eastern", "Luapula", "Lusaka", "Muchinga", 
    "Northern", "North-Western", "Southern", "Western"],
  "Zimbabwe": [
    "Bulawayo", "Harare", "Manicaland", "Mashonaland Central", "Mashonaland East", 
    "Mashonaland West", "Masvingo", "Matabeleland North", "Matabeleland South", "Midlands"
  ],
  Fiji: ["Ba", "Bua", "Cakaudrove", "Kadavu", "Lau", "Lomaiviti", "Macuata", "Nadroga-Navosa", "Naitasiri", "Namosi", "Ra", "Rewa", "Serua", "Tailevu"],
  Kiribati: ["Gilbert Islands", "Line Islands", "Phoenix Islands"],
  MarshallIslands: ["Ratak Chain", "Ralik Chain"],
  MicronesiaFederatedStates: ["Chuuk", "Kosrae", "Pohnpei", "Yap"],
  Nauru: ["Aiwo", "Anabar", "Anetan", "Anibare", "Baiti", "Boe", "Buada", "Denigomodu", "Ewa", "Ijuw", "Meneng", "Nibok", "Uaboe", "Yaren"],
  Palau: ["Aimeliik", "Airai", "Angaur", "Hatohobei", "Kayangel", "Koror", "Melekeok", "Ngaraard", "Ngarchelong", "Ngardmau", "Ngatpang", "Ngchesar", "Ngeremlengui", "Ngiwal", "Peleliu", "Sonsorol"],
  PapuaNewGuinea: ["Bougainville", "Central", "Chimbu", "East New Britain", "East Sepik", "Eastern Highlands", 
    "Enga", "Gulf", "Hela", "Jiwaka", "Madang", "Manus", "Milne Bay", "Morobe", "New Ireland", "Northern", "Sandaun", "Southern Highlands", "Western", "Western Highlands", "West New Britain"],
  Samoa: ["A'ana", "Aiga-i-le-Tai", "Atua", "Fa'asaleleaga", "Gaga'emauga", "Gaga'ifomauga", "Palauli", "Satupa'itea", "Tuamasaga", "Va'a-o-Fonoti", "Vaisigano"],
  SolomonIslands: ["Central", "Choiseul", "Guadalcanal", "Honiara", "Isabel", "Makira-Ulawa", "Malaita", "Rennell and Bellona", "Temotu", "Western"],
  Tonga: ["Eua", "Ha'apai", "Niuas", "Tongatapu", "Vava'u"],
  Tuvalu: ["Funafuti", "Nanumanga", "Nanumea", "Niutao", "Nui", "Nukufetau", "Nukulaelae", "Vaitupu"],
  Vanuatu: ["Malampa", "Penama", "Sanma", "Shefa", "Tafea", "Torba"],
  "Armenia": ["Aragatsotn", "Ararat", "Armavir", "Gegharkunik", "Kotayk", "Lori", "Shirak", "Syunik", "Tavush", "Vayots Dzor", "Yerevan"],
  "Azerbaijan": [
    "Absheron", "Agstafa", "Agdam", "Agdash", "Aghjabadi", "Astara", "Balakan", "Barda", "Baku", "Beylagan", "Bilasuvar", "Dashkasan", "Fuzuli", "Ganja", "Goranboy", "Goychay", "Goygol", "Hajigabul", "Imishli", "Ismailli", "Jabrayil", "Jalilabad",
    "Kalbajar", "Khachmaz", "Khizi", "Kurdamir", "Lachin", "Lankaran", "Lerik", "Masally", "Mingachevir", "Naftalan",
    "Nakhchivan", "Neftchala", "Oguz", "Qabala", "Qakh", "Qazakh", "Quba", "Qubadli", "Qusar", "Saatly", "Sabirabad", "Salyan",
    "Samukh", "Shabran", "Shaki", "Shamakhi", "Shirvan", "Shusha", "Siazan", "Sumqayit", "Tartar", "Tovuz", "Ujar",
    "Yardimli", "Yevlakh", "Zaqatala", "Zangilan", "Zardab"
  ],
  "Georgia": ["Abkhazia", "Adjara", "Guria", "Imereti", "Kakheti", "Kvemo Kartli", "Mtskheta-Mtianeti", "Racha-Lechkhumi and Kvemo Svaneti", "Samegrelo-Zemo Svaneti", "Samtskhe-Javakheti", "Shida Kartli", "Tbilisi"],
  "Kazakhstan": ["Akmola", "Aktobe", "Almaty", "Atyrau", "East Kazakhstan", "Jambyl", "Karaganda", "Kostanay", "Kyzylorda", "Mangystau", "North Kazakhstan", "Pavlodar", "South Kazakhstan", "West Kazakhstan", "Zhambyl"],
  "Kosovo": ["Ferizaj", "Gjakova", "Gjilan", "Mitrovica", "Peja", "Pristina", "Prizren"],
  "Faroe Islands": ["Eysturoy", "Norðoyar", "Sandoy", "Streymoy", "Suðuroy", "Vágar"],
  "Saint Pierre and Miquelon": ["Saint Pierre", "Miquelon"],
  "Montserrat": ["Saint Anthony", "Saint Georges", "Saint Peter"],
  "Aruba": ["Oranjestad", "San Nicolas", "Noord", "Paradera", "Santa Cruz", "Savaneta"],
  "Falkland Islands": ["East Falkland", "West Falkland"],
  "South Georgia and the South Sandwich Islands": ["NSouth Georgia and the South Sandwich Islands"],
  "Bonaire": ["Bonaire", "Sint Eustatius", "Saba"],
  "Curaçao": ["Curaçao"],
  "Sint Maarten": ["Sint Maarten"],
  "Cook Islands": ["Aitutaki", "Atiu", "Mangaia", "Manihiki", "Mauke", "Mitiaro", "Nassau", "Palmerston", "Penrhyn", "Pukapuka", "Rakahanga", "Rarotonga", "Takutea"],
  "Niue": ["Alofi North", "Alofi South"],
  "Pitcairn Islands": ["Pitcairn Island"],
  "Tokelau": ["Atafu", "Fakaofo", "Nukunonu"],
  "Wallis and Futuna": ["Alo", "Sigave", "Uvea"],
  "New Caledonia": ["North Province", "South Province", "Loyalty Islands Province"],
  "French Polynesia": ["Austral Islands", "Gambier Islands", "Marquesas Islands", "Society Islands", "Tuamotu Islands"],
  "Guam": ["Guam"],
  "Northern Mariana Islands": ["Rota", "Saipan", "Tinian"],
  "American Samoa": ["Tutuila", "Aunu'u", "Ofu", "Olosega", "Ta'ū", "Swains Island"],
  "Christmas Island": ["Christmas Island"],
  "Turkmenistan": ["Ahal", "Balkan", "Dashoguz", "Lebap", "Mary", "Ashgabat"],
  "Kyrgyzstan": ["Batken", "Chuy", "Jalal-Abad", "Naryn", "Osh", "Talas", "Issyk-Kul"],
  "Uzbekistan": ["Andijan", "Bukhara", "Fergana", "Jizzakh", "Khorezm", "Namangan", "Navoiy", "Qashqadaryo", "Samarkand", "Sirdaryo", "Surxondaryo", "Tashkent", "Karakalpakstan"],
  "Tajikistan": ["Sughd", "Khatlon", "Gorno-Badakhshan", "Districts of Republican Subordination", "Dushanbe"],
 "Greenland": ["Avannaata", "Kujalleq", "Qeqertalik", "Qeqqata", "Sermersooq"],
  "Bouvet Island": ["Bouvet Island"],
  "Saint Barthélemy": ["Saint Barthélemy"],
  "Saint Martin": ["Saint Martin"],
  
  // Add more countries and states as needed
  };
  
  export const districts = {
  "Andhra Pradesh": ["Anantapur", "Chittoor", "East Godavari", "Guntur", "Krishna", "Kurnool", "Prakasam", "Sri Potti Sriramulu Nellore", "Srikakulam", "Visakhapatnam", "Vizianagaram", "West Godavari", "YSR Kadapa"],
  "Arunachal Pradesh": ["Anjaw", "Changlang", "Dibang Valley", "East Kameng", "East Siang", "Kamle", "Kra Daadi", "Kurung Kumey", "Lepa Rada", "Lohit", "Longding", "Lower Dibang Valley", "Lower Siang", "Lower Subansiri", "Namsai", "Pakke Kessang", "Papum Pare", "Shi Yomi", "Siang", "Tawang", "Tirap", "Upper Siang", "Upper Subansiri", "West Kameng", "West Siang"],
  "Assam": ["Baksa", "Barpeta", "Biswanath", "Bongaigaon", "Cachar", "Charaideo", "Chirang", "Darrang", "Dhemaji", "Dhubri", "Dibrugarh", "Goalpara", "Golaghat", "Hailakandi", "Hojai", "Jorhat", "Kamrup", "Kamrup Metropolitan", "Karbi Anglong", "Karimganj", "Kokrajhar", "Lakhimpur", "Majuli", "Morigaon", "Nagaon", "Nalbari", "Sivasagar", "Sonitpur", "South Salmara-Mankachar", "Tinsukia", "Udalguri", "West Karbi Anglong"],
  "Bihar": ["Araria", "Arwal", "Aurangabad", "Banka", "Begusarai", "Bhagalpur", "Bhojpur", "Buxar", "Darbhanga", "East Champaran", "Gaya", "Gopalganj", "Jamui", "Jehanabad", "Kaimur", "Katihar", "Khagaria", "Kishanganj", "Lakhisarai", "Madhepura", "Madhubani", "Munger", "Muzaffarpur", "Nalanda", "Nawada", "Patna", "Purnia", "Rohtas", "Saharsa", "Samastipur", "Saran", "Sheikhpura", "Sheohar", "Sitamarhi", "Siwan", "Supaul", "Vaishali", "West Champaran"],
  "Chhattisgarh": ["Balod", "Baloda Bazar", "Balrampur", "Bastar", "Bemetara", "Bijapur", "Bilaspur", "Dantewada (South Bastar)", "Dhamtari", "Durg", "Gariaband", "Gaurela-Pendra-Marwahi", "Janjgir-Champa", "Jashpur", "Kabirdham (Kawardha)", "Kanker (North Bastar)", "Kondagaon", "Korba", "Koriya", "Mahasamund", "Mungeli", "Narayanpur", "Raigarh", "Raipur", "Rajnandgaon", "Sukma", "Surajpur", "Surguja"],
  "Goa": ["North Goa", "South Goa"],
  "Gujarat": ["Ahmedabad", "Amreli", "Anand", "Aravalli", "Banaskantha (Palanpur)", "Bharuch", "Bhavnagar", "Botad", "Chhota Udaipur", "Dahod", "Dang (Ahwa)", "Devbhoomi Dwarka", "Gandhinagar", "Gir Somnath", "Jamnagar", "Junagadh", "Kheda (Nadiad)", "Kutch", "Mahisagar", "Mehsana", "Morbi", "Narmada (Rajpipla)", "Navsari", "Panchmahal (Godhra)", "Patan", "Porbandar", "Rajkot", "Sabarkantha (Himmatnagar)", "Surat", "Surendranagar", "Tapi (Vyara)", "Vadodara", "Valsad"],
  "Haryana": ["Ambala", "Bhiwani", "Charkhi Dadri", "Faridabad", "Fatehabad", "Gurugram (Gurgaon)", "Hisar", "Jhajjar", "Jind", "Kaithal", "Karnal", "Kurukshetra", "Mahendragarh", "Nuh", "Palwal", "Panchkula", "Panipat", "Rewari", "Rohtak", "Sirsa", "Sonipat", "Yamunanagar"],
  "Himachal Pradesh": ["Bilaspur", "Chamba", "Hamirpur", "Kangra", "Kinnaur", "Kullu", "Lahaul & Spiti", "Mandi", "Shimla", "Sirmaur", "Solan", "Una"],
  "Jharkhand": ["Bokaro", "Chatra", "Deoghar", "Dhanbad", "Dumka", "East Singhbhum", "Garhwa", "Giridih", "Godda", "Gumla", "Hazaribagh", "Jamtara", "Khunti", "Koderma", "Latehar", "Lohardaga", "Pakur", "Palamu", "Ramgarh", "Ranchi", "Sahibganj", "Seraikela-Kharsawan", "Simdega", "West Singhbhum"],
  "Karnataka": ["Bagalkot", "Ballari (Bellary)", "Belagavi (Belgaum)", "Bengaluru (Bangalore) Rural", "Bengaluru (Bangalore) Urban", "Bidar", "Chamarajanagar", "Chikkaballapur", "Chikkamagaluru (Chikmagalur)", "Chitradurga", "Dakshina Kannada", "Davanagere", "Dharwad", "Gadag", "Hassan", "Haveri", "Kalaburagi (Gulbarga)", "Kodagu", "Kolar", "Koppal", "Mandya", "Mysuru (Mysore)", "Raichur", "Ramanagara", "Shivamogga (Shimoga)", "Tumakuru (Tumkur)", "Udupi", "Uttara Kannada (Karwar)", "Vijayapura (Bijapur)", "Yadgir"],
  "Kerala": ["Alappuzha", "Ernakulam", "Idukki", "Kannur", "Kasaragod", "Kollam", "Kottayam", "Kozhikode", "Malappuram", "Palakkad", "Pathanamthitta", "Thiruvananthapuram", "Thrissur", "Wayanad"],
  "Madhya Pradesh": ["Agar Malwa", "Alirajpur", "Anuppur", "Ashoknagar", "Balaghat", "Barwani", "Betul", "Bhind", "Bhopal", "Burhanpur", "Chhatarpur", "Chhindwara", "Damoh", "Datia", "Dewas", "Dhar", "Dindori", "Guna", "Gwalior", "Harda", "Hoshangabad", "Indore", "Jabalpur", "Jhabua", "Katni", "Khandwa", "Khargone", "Mandla", "Mandsaur", "Morena", "Narsinghpur", "Neemuch", "Panna", "Raisen", "Rajgarh", "Ratlam", "Rewa", "Sagar", "Satna", "Sehore", "Seoni", "Shahdol", "Shajapur", "Sheopur", "Shivpuri", "Sidhi", "Singrauli", "Tikamgarh", "Ujjain", "Umaria", "Vidisha"],
  "Maharashtra": ["Ahmednagar", "Akola", "Amravati", "Aurangabad", "Beed", "Bhandara", "Buldhana", "Chandrapur", "Dhule", "Gadchiroli", "Gondia", "Hingoli", "Jalgaon", "Jalna", "Kolhapur", "Latur", "Mumbai City", "Mumbai Suburban", "Nagpur", "Nanded", "Nandurbar", "Nashik", "Osmanabad", "Palghar", "Parbhani", "Pune", "Raigad", "Ratnagiri", "Sangli", "Satara", "Sindhudurg", "Solapur", "Thane", "Wardha", "Washim", "Yavatmal"],
  "Manipur": ["Bishnupur", "Chandel", "Churachandpur", "Imphal East", "Imphal West", "Jiribam", "Kakching", "Kamjong", "Kangpokpi", "Noney", "Pherzawl", "Senapati", "Tamenglong", "Tengnoupal", "Thoubal", "Ukhrul"],
  "Meghalaya": ["East Garo Hills", "East Jaintia Hills", "East Khasi Hills", "North Garo Hills", "Ri Bhoi", "South Garo Hills", "South West Garo Hills", "South West Khasi Hills", "West Garo Hills", "West Jaintia Hills", "West Khasi Hills"],
  "Mizoram": ["Aizawl", "Champhai", "Hnahthial", "Khawzawl", "Kolasib", "Lawngtlai", "Lunglei", "Mamit", "Saiha", "Saitual", "Serchhip"],
  "Nagaland": ["Chümoukedima", "Dimapur", "Kiphire", "Kohima", "Longleng", "Mokokchung", "Mon", "Niuland", "Noklak", "Peren", "Phek", "Tseminyu", "Tuensang", "Wokha", "Zunheboto"],
  "Odisha": ["Angul", "Balangir", "Balasore", "Bargarh", "Bhadrak", "Boudh", "Cuttack", "Deogarh", "Dhenkanal", "Gajapati", "Ganjam", "Jagatsinghpur", "Jajpur", "Jharsuguda", "Kalahandi", "Kandhamal", "Kendrapara", "Kendujhar", "Khordha", "Koraput", "Malkangiri", "Mayurbhanj", "Nabarangpur", "Nayagarh", "Nuapada", "Puri", "Rayagada", "Sambalpur", "Subarnapur", "Sundargarh"],
  "Punjab": ["Amritsar", "Barnala", "Bathinda", "Faridkot", "Fatehgarh Sahib", "Fazilka", "Ferozepur", "Gurdaspur", "Hoshiarpur", "Jalandhar", "Kapurthala", "Ludhiana", "Mansa", "Moga", "Muktsar", "Nawanshahr (Shahid Bhagat Singh Nagar)", "Pathankot", "Patiala", "Rupnagar", "Sangrur", "Tarn Taran"],
  "Rajasthan": ["Ajmer", "Alwar", "Banswara", "Baran", "Barmer", "Bharatpur", "Bhilwara", "Bikaner", "Bundi", "Chittorgarh", "Churu", "Dausa", "Dholpur", "Dungarpur", "Hanumangarh", "Jaipur", "Jaisalmer", "Jalore", "Jhalawar", "Jhunjhunu", "Jodhpur", "Karauli", "Kota", "Nagaur", "Pali", "Pratapgarh", "Rajsamand", "Sawai Madhopur", "Sikar", "Sirohi", "Sri Ganganagar", "Tonk", "Udaipur"],
  "Sikkim": ["East Sikkim", "North Sikkim", "South Sikkim", "West Sikkim"],
  "Tamil Nadu": ["Ariyalur", "Chengalpattu", "Chennai", "Coimbatore", "Cuddalore", "Dharmapuri", "Dindigul", "Erode", "Kallakurichi", "Kanchipuram", "Kanyakumari", "Karur", "Krishnagiri", "Madurai", "Mayiladuthurai", "Nagapattinam", "Namakkal", "Nilgiris", "Perambalur", "Pudukkottai", "Ramanathapuram", "Ranipet", "Salem", "Sivaganga", "Tenkasi", "Thanjavur", "Theni", "Thoothukudi", "Tiruchirappalli", "Tirunelveli", "Tirupathur", "Tiruppur", "Tiruvallur", "Tiruvannamalai", "Tiruvarur", "Vellore", "Viluppuram", "Virudhunagar"],
  "Telangana": ["Adilabad", "Bhadradri Kothagudem", "Hyderabad", "Jagtial", "Jangaon", "Jayashankar Bhupalpally", "Jogulamba Gadwal", "Kamareddy", "Karimnagar", "Khammam", "Kumuram Bheem Asifabad", "Mahabubabad", "Mahabubnagar", "Mancherial", "Medak", "Medchal-Malkajgiri", "Mulugu", "Nagarkurnool", "Nalgonda", "Narayanpet", "Nirmal", "Nizamabad", "Peddapalli", "Rajanna Sircilla", "Rangareddy", "Sangareddy", "Siddipet", "Suryapet", "Vikarabad", "Wanaparthy", "Warangal (Rural)", "Warangal (Urban)", "Yadadri Bhuvanagiri"],
  "Tripura": ["Dhalai", "Gomati", "Khowai", "North Tripura", "Sepahijala", "South Tripura", "Unakoti", "West Tripura"],
  "Uttar Pradesh": ["Agra", "Aligarh", "Ambedkar Nagar", "Amethi", "Amroha", "Auraiya", "Ayodhya", "Azamgarh", "Baghpat", "Bahraich", "Ballia", "Balrampur", "Banda", "Barabanki", "Bareilly", "Basti", "Bhadohi", "Bijnor", "Budaun", "Bulandshahr", "Chandauli", "Chitrakoot", "Deoria", "Etah", "Etawah", "Farrukhabad", "Fatehpur", "Firozabad", "Gautam Buddha Nagar", "Ghaziabad", "Ghazipur", "Gonda", "Gorakhpur", "Hamirpur", "Hardoi", "Hathras", "Jalaun", "Jaunpur", "Jhansi", "Kannauj", "Kanpur Dehat", "Kanpur Nagar", "Kaushambi", "Kheri", "Kushinagar", "Lalitpur", "Lucknow", "Maharajganj", "Mathura", "Meerut", "Mirzapur", "Moradabad", "Muzaffarnagar", "Pilibhit", "Pratapgarh", "Prayagraj", "Raebareli", "Rampur", "Saharanpur", "Sant Kabir Nagar", "Shahjahanpur", "Shamli", "Sitapur", "Sonbhadra", "Sultanpur", "Unnao", "Varanasi"], 
  "Uttarakhand": ["Almora", "Bageshwar", "Chamoli", "Champawat", "Dehradun", "Haridwar",
    "Nainital", "Pauri Garhwal", "Pithoragarh", "Rudraprayag", "Tehri Garhwal", "Udham Singh Nagar", "Uttarkashi"
  ],
  "West Bengal": ["Alipurduar", "Bankura", "Birbhum", "Cooch Behar", "Dakshin Dinajpur", "Darjeeling",
    "Hooghly", "Howrah", "Jalpaiguri", "Jhargram", "Kalimpong", "Kolkata",
    "Malda", "Murshidabad", "Nadia", "North 24 Parganas", "Paschim Bardhaman", 
    "Paschim Medinipur", "Purba Bardhaman", "Purba Medinipur", "Purulia", 
    "South 24 Parganas", "Uttar Dinajpur"],
  "Andaman and Nicobar Islands": ["Nicobar", "North and Middle Andaman", "South Andaman"],
  "Chandigarh": ["Chandigarh"],
  "Dadra and Nagar Haveli and Daman and Diu": ["Dadra and Nagar Haveli", "Daman", "Diu"],
  "Delhi": ["Central Delhi", "East Delhi", "New Delhi", "North Delhi", "North East Delhi",
    "North West Delhi", "Shahdara", "South Delhi", "South East Delhi",
    "South West Delhi", "West Delhi"],
  "Jammu and Kashmir": ["Anantnag", "Bandipora", "Baramulla", "Budgam", "Doda", "Ganderbal", "Jammu", "Kathua", "Kishtwar", "Kulgam", "Kupwara", "Poonch", "Pulwama", "Rajouri", "Ramban", "Reasi", "Samba", "Shopian", "Srinagar", "Udhampur"],
  "Ladakh": ["Kargil", "Leh"],
  "Lakshadweep": ["Agatti", "Amini", "Andrott", "Bitra", "Chetlat", "Kadmat", "Kalpeni", "Kavaratti", "Kilthan", "Minicoy"],
  "Puducherry": ["Karaikal", "Mahe", "Puducherry", "Yanam"],
  
  
  //USA//
  "New York": ["Albany", "Buffalo", "Rochester", "Syracuse", "Yonkers", "Bronx", "Manhattan", "Queens", "Brooklyn", "Staten Island"],
  California: [
    "Los Angeles", "San Diego", "San Francisco", "San Jose", "Fresno", "Sacramento", 
    "Oakland", "Long Beach", "Santa Ana", "Bakersfield", "Anaheim"
  ],
 
  Bavaria: [
    "Munich", "Nuremberg", "Augsburg", "Regensburg", "Ingolstadt", "Würzburg", 
    "Erlangen", "Bamberg", "Bayreuth", "Fürth", "Aschaffenburg"
  ],
  Quebec: [
    "Montreal", "Quebec City", "Laval", "Gatineau", "Longueuil", "Sherbrooke", 
    "Saguenay", "Trois-Rivières", "Terrebonne", "Saint-Jean-sur-Richelieu"
  ],
  // UAE//
  "Abu Dhabi": ["Abu Dhabi City", "Al Ain", "Madinat Zayed", "Ruwais"],
  "Dubai": ["Dubai City", "Hatta"],
  "Sharjah": ["Sharjah City", "Khor Fakkan", "Kalba", "Dibba Al-Hisn"],
  "Ajman": ["Ajman City", "Masfout", "Manama"],
  "Umm Al-Quwain": ["Umm Al-Quwain City", "Falaj Al Mualla"],
  "Ras Al Khaimah": ["Ras Al Khaimah City", "Digdaga", "Al Rams"],
  "Fujairah": ["Fujairah City", "Dibba", "Masafi", "Mirbah"],

//KSA//
  "Riyadh": ["Riyadh", "Al-Kharj", "Al-Majma'ah", "Dawadmi", "Shaqra", "Afif", "Wadi ad-Dawasir", "Al-Zulfi", "Hotat Bani Tamim", "Al-Sulayyil"],
  "Makkah": ["Makkah", "Jeddah", "Ta'if", "Rabigh", "Al-Lith", "Al-Qunfudhah", "Khulays", "Turubah", "Ranyah", "Al-Jumum"],
  "Madinah": ["Madinah", "Yanbu", "Al-Ula", "Khaybar", "Badr", "Mahd adh Dhahab"],
  "Eastern Province": ["Dammam", "Al-Khobar", "Dhahran", "Jubail", "Al-Ahsa", "Qatif", "Ras Tanura", "Abqaiq", "Hafar Al-Batin", "Khafji", "Nairiyah"],
  "Al-Qassim": ["Buraydah", "Unaizah", "Ar Rass", "Al-Mithnab", "Al-Bukayriyah", "Al-Badayea", "Riyadh Al-Khabra"],
  "Hail": ["Hail", "Baqaa", "Al-Ghazalah", "Shinan"],
  "Asir": ["Abha", "Khamis Mushait", "Bisha", "Ahad Rafidah", "Al-Namas", "Muhayil", "Rijal Almaa", "Sarat Abidah"],
  "Tabuk": ["Tabuk", "Duba", "Al-Wajh", "Tayma", "Haql", "Umluj"],
  "Jazan": ["Jazan", "Sabya", "Abu Arish", "Samtah", "Al-Darb", "Baish", "Farasan", "Al-Rayth"],
  "Najran": ["Najran", "Sharurah", "Habuna", "Badr Al-Janub", "Yadamah"],
  "Al-Bahah": ["Al-Bahah", "Baljurashi", "Al-Mandaq", "Al-Qara"],
  "Al-Jawf": ["Sakakah", "Domat Al-Jandal", "Tabarjal"],
  "Northern Borders": ["Arar", "Rafha", "Turaif"],

England: [
    "Bedfordshire", "Berkshire", "Bristol", "Buckinghamshire", "Cambridgeshire", "Cheshire",
    "City of London", "Cornwall", "Cumbria", "Derbyshire", "Devon", "Dorset",
    "Durham", "East Riding of Yorkshire", "East Sussex", "Essex", "Gloucestershire",
    "Greater London", "Greater Manchester", "Hampshire", "Herefordshire", "Hertfordshire",
    "Isle of Wight", "Kent", "Lancashire", "Leicestershire", "Lincolnshire", "Merseyside",
    "Norfolk", "North Yorkshire", "Northamptonshire", "Northumberland", "Nottinghamshire",
    "Oxfordshire", "Rutland", "Shropshire", "Somerset", "South Yorkshire", "Staffordshire",
    "Suffolk", "Surrey", "Tyne and Wear", "Warwickshire", "West Midlands", "West Sussex",
    "West Yorkshire", "Wiltshire", "Worcestershire"
  ],

  Scotland: [
    "Aberdeen City", "Aberdeenshire", "Angus", "Argyll and Bute", "Clackmannanshire",
    "Dumfries and Galloway", "Dundee City", "East Ayrshire", "East Dunbartonshire",
    "East Lothian", "East Renfrewshire", "Edinburgh (City of)", "Falkirk", "Fife",
    "Glasgow City", "Highland", "Inverclyde", "Midlothian", "Moray", "Na h-Eileanan Siar",
    "North Ayrshire", "North Lanarkshire", "Orkney Islands", "Perth and Kinross",
    "Renfrewshire", "Scottish Borders", "Shetland Islands", "South Ayrshire",
    "South Lanarkshire", "Stirling", "West Dunbartonshire", "West Lothian"
  ],

  Wales: [
    "Blaenau Gwent", "Bridgend", "Caerphilly", "Cardiff", "Carmarthenshire",
    "Ceredigion", "Conwy", "Denbighshire", "Flintshire", "Gwynedd", "Isle of Anglesey",
    "Merthyr Tydfil", "Monmouthshire", "Neath Port Talbot", "Newport", "Pembrokeshire",
    "Powys", "Rhondda Cynon Taf", "Swansea", "Torfaen", "Vale of Glamorgan", "Wrexham"
  ],

  "Northern Ireland": [
    "Antrim and Newtownabbey", "Ards and North Down", "Armagh City, Banbridge and Craigavon",
    "Belfast", "Causeway Coast and Glens", "Derry City and Strabane", "Fermanagh and Omagh",
    "Lisburn and Castlereagh", "Mid and East Antrim", "Mid Ulster", "Newry, Mourne and Down"
  ],

};
  